import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Card, CardContent, CardHeader, Stack } from '@packages/shared';
import { defineMessage, useIntl } from 'react-intl';
import { EcoLabelItem } from '../EcoLabelItem';

const EcoLabelCardFragment = graphql(/* GraphQL */ `
  fragment EcoLabelCardFragment on Product {
    ecoLabels {
      ...EcoLabelItemFragment
    }
  }
`);

export type EcoLabelCardProps = {
  ecoLabels: FragmentType<typeof EcoLabelCardFragment>;
};

const message = defineMessage({
  defaultMessage: 'Nachhaltigkeit',
  id: 'ecoLabelList.dialog.headline',
});

/**
 * <p>This component renders all eco-labels of a product.</p>
 * <i>A product can have multiple eco-labels.</i>
 * */
export const EcoLabelCard = ({ ecoLabels }: EcoLabelCardProps) => {
  const { formatMessage } = useIntl();
  const { ecoLabels: ecoLabelsList } = getFragmentData(EcoLabelCardFragment, ecoLabels);

  if (ecoLabelsList.length === 0) return null;

  return (
    <Card>
      <CardHeader
        title={formatMessage(message)}
        sx={{
          borderBottom: 1,
          borderColor: 'grey.main',
          py: 1,
          px: 2,
        }}
      />
      <CardContent>
        <Stack gap={1.5}>
          {ecoLabelsList.map((ecoLabel, idx) => (
            <EcoLabelItem
              // is disabled because this list is not being reordered
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
              ecoLabelData={ecoLabel}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
